import React from "react";

const Stars = (props) =>
{
    const reviews = props.reviews || false;  
    let total = reviews.length;

    const calculateRate = (rates) =>
    {       
        if(rates === undefined) return false;
        
        let sum = 0;
        total = rates.length
        const len = rates.length        

        rates.map(rate =>
        {
            sum +=(rate*1)
            return true
        })    

        return Math.ceil(sum/len);
    }   
    
    const Stars = ({rate}) =>  
    {
        if(props.calculate) rate = calculateRate(props.calculate)           
        
        let stars = [];        
        for (let index = 1; index <= 5; index++) 
        {                       
            let rated = (5*rate/100)+'' 
                rated = rated.split('.')
            
            let decimal = rated[1] !== undefined ? rated[1].substring(0, 1) : false
            let width = '0%'                           

            if(rated[0]*1 >= index) width = '100%' 
            if(decimal !== false && (rated[0]*1 - index) === -1 ) width = decimal+'0%' 

            const style = {
                width: width
            }

            stars.push(
                <div key={index} className={!props.page ? "starbg" : `starbg-${props.page}`}>
                    <div style={style} className={!props.page ? "star on" : `star-${props.page} on`}></div>  
                </div>
            )                   
        }

        return stars;
    }

    const RateNum = (rate) =>
    {           
        if(props.calculate) rate = calculateRate(props.calculate)        
        return ( (rate/20).toFixed(1) )
    }

    const Render = () =>
    {           
        if(props.calculate && !calculateRate(props.calculate)) return <></>  
        
        const url = props.url !== undefined ? props.url+'#reviews' : '#reviews';
        
        return (
            <div className="rating">
                {props.showNumber !== false ? (
                    <div className="number">{RateNum(props.rate || 0)}</div>
                ) : (
                    <div style={{ marginLeft: '-12px' }} />
                )}
                <div className="stars">
                    <Stars rate={props.rate || 0} />
                </div>
                {reviews && (
                    <div className="reviews">
                        <a href={url}>
                            <span>{total}</span> verified review{total > 1 ? "s" : ""}
                        </a>
                    </div>
                )}
            </div>
        )
    }
    
    return(
        <Render/>    
    )
}

export default Stars